'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

require('./index.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _apiIconWhite2x = require('../../../../../static/images/v2/modules/home/api-icon-white@2x.png');

var _apiIconWhite2x2 = _interopRequireDefault(_apiIconWhite2x);

var _eventbrite_logo = require('./assets/eventbrite_logo.png');

var _eventbrite_logo2 = _interopRequireDefault(_eventbrite_logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ANIMATION_INTERVAL = 7000;
var ANIMATION_FADEOUT_SPEED = 320;
var ANIMATE_IN = 'animate-in';
var ANIMATE_OUT = 'animate-out';
var ANNOUNCEMENTS = [EventbriteBar, APIBar];

var baseButtonProps = {
    buttonText: 'Learn more',
    buttonColor: 'white',
    buttonHoverColor: 'grasshopper',
    buttonTextColor: 'black',
    buttonHoverTextColor: 'white'
};

var _ref = _jsx('img', {
    src: _apiIconWhite2x2['default']
});

function APIBar(props) {
    var animation = props.animation;

    var buttonProps = Object.assign({}, baseButtonProps, { buttonLink: '/info/api' });
    return _jsx('div', {
        className: 'm-home-api--inner row ' + animation
    }, void 0, _jsx('span', {
        className: 'm-home-api--icon'
    }, void 0, _ref), _jsx('span', {
        className: 'm-home-api--text'
    }, void 0, 'Integrate eSignatures into your website with our API.'), _jsx('span', {
        className: 'm-home-api--cta'
    }, void 0, _react2['default'].createElement(_button2['default'], buttonProps)));
}

function EventbriteBar(props) {
    var animation = props.animation;

    var buttonProps = Object.assign({}, baseButtonProps, { buttonLink: 'https://www.hellosign.com/eventbrite' });
    return _jsx('div', {
        className: 'm-home-api--inner row ' + animation
    }, void 0, _jsx('span', {
        className: 'm-home-api--icon',
        style: { width: 125 }
    }, void 0, _jsx('img', {
        src: _eventbrite_logo2['default'],
        style: { minWidth: 125 }
    })), _jsx('span', {
        className: 'm-home-api--text'
    }, void 0, 'We\'ve integrated with Eventbrite to simplify waivers and forms for event organizers.'), _jsx('span', {
        className: 'm-home-api--cta'
    }, void 0, _react2['default'].createElement(_button2['default'], buttonProps)));
}

var BlackBarAnnouncements = function (_React$Component) {
    _inherits(BlackBarAnnouncements, _React$Component);

    function BlackBarAnnouncements(props) {
        _classCallCheck(this, BlackBarAnnouncements);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BlackBarAnnouncements).call(this, props));

        _this.clearInterval = _this.clearInterval.bind(_this);
        _this.initiateAnimations = _this.initiateAnimations.bind(_this);
        _this.animate = _this.animate.bind(_this);
        _this.incrementIndex = _this.incrementIndex.bind(_this);
        _this.state = {
            // If no animate, don't show eventbrite bar. Otherwise, Eventbrite
            // should be the first bar to render
            currentComponentIndex: _this.props.shouldAnimate ? 0 : 1,
            currentAnimation: ANIMATE_IN,
            timerId: null
        };
        return _this;
    }

    _createClass(BlackBarAnnouncements, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.shouldAnimate) this.initiateAnimations();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearInterval();
        }
    }, {
        key: 'initiateAnimations',
        value: function initiateAnimations() {
            var _this2 = this;

            var interval = setInterval(function () {
                return _this2.animate();
            }, ANIMATION_INTERVAL);
            this.setState({ timerId: interval });
        }
    }, {
        key: 'clearInterval',
        value: function clearInterval() {
            var timerId = this.state.timerId;

            if (timerId) clearTimeout(timerId);
            this.setState({ timerId: null });
        }
    }, {
        key: 'animate',
        value: function animate() {
            var _this3 = this;

            this.setState({ currentAnimation: ANIMATE_OUT });
            setTimeout(function () {
                return _this3.incrementIndex();
            }, ANIMATION_FADEOUT_SPEED);
        }
    }, {
        key: 'incrementIndex',
        value: function incrementIndex() {
            var currentComponentIndex = this.state.currentComponentIndex;

            var nextComponentIndex = (currentComponentIndex + 1) % ANNOUNCEMENTS.length;
            this.setState({
                currentComponentIndex: nextComponentIndex,
                currentAnimation: ANIMATE_IN
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state;
            var currentComponentIndex = _state.currentComponentIndex;
            var currentAnimation = _state.currentAnimation;

            var CurrentAnnouncement = ANNOUNCEMENTS[currentComponentIndex];
            return _jsx(CurrentAnnouncement, {
                animation: currentAnimation
            });
        }
    }]);

    return BlackBarAnnouncements;
}(_react2['default'].Component);

module.exports = BlackBarAnnouncements;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/home/black-bar-announcements/index.jsx
 ** module id = 775
 ** module chunks = 0
 **/